define('models/help',['require','models/base/model','config/application'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        configApplication = require('config/application');

    var HelpModel = Model.extend({
        urlPath: function() {
            return ['/api/help', configApplication.appId, this.get('id')].join('/');
        },
        defaults: {
            title: '',
            content: ''
        }
    });

    return HelpModel;
});
